export default "__VITE_PUBLIC_ASSET__322c5860__"